
<template>
  <div>
    <v-autocomplete 
      v-model="selected_modality"
      :readonly="readonly"
      :chips="multiple" 
      :multiple="multiple" 
      :loading="loading_modules" 
      :label="label ? label : 'Selecione a região ou galpão'" 
      :items="filtered_modalities"
      :rules="is_required ? [...required] : []" 
      :clearable="clearable"
      prepend-icon="mdi-star" 
      item-text="name" 
      item-value="id" 
    >
      <template slot="append" v-if="modalities.length == 0 && !loading_modules"> 
        <v-btn icon @click="getModalities()">
          <v-icon>mdi-refresh</v-icon>
        </v-btn>
      </template>
    </v-autocomplete>
  </div>
</template>

<script>

import validations from "@/mixins/validations.js"
import change_module from "@/mixins/change_module.js"

export default {
  name: 'SelectDepot',
  mixins: [validations, change_module],
  props:{
    filter:{
      type:Object,
      default: () => { return {} }
    },
    selected_ids:{
      type: Array,
      default: null,
    },
    is_required: {
      type: Boolean,
      default: true
    },
    label: {
      type: String,
      default: null
    },
    clearable: {
      type: Boolean,
      default: false
    },
    readonly:{
      type: Boolean,
      default: false,
    },
    list_all: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    filtered_modalities() {
      if(this.list_all){
        return this.filter_modalities
      }else{
        return this.filter_modalities.filter(el=> el.id != -1)
      }
    }
  },
}
</script>
